export default "__VITE_ASSET__D$WboE4v__"